import LoginPageContainer from "./LoginPageContainer";

export default LoginPageContainer;
